import { PropsChildren } from '@/types/common';
import React from 'react';

const Layout: React.FC<PropsChildren> = ({ children }) => {
  return <div className="relative w-full h-auto">{children}</div>;
};

export default Layout;
